module.exports = __webpack_public_path__ + "img/increase-energy.8e29584a.svg";